<script setup>
import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

</script>

<template>
    <radio-group-inline
        label="Layout"
        name="public_page_content_layout"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.public_page_content_layout ?? 'border'"
        @update:model-value="portalContentAndDesignStore.portalLayoutSettings.public_page_content_layout = $event"
        :options="[
          { value: 'one', label: 'Default'},
          { value: 'two', label: 'Casual'},
    ]">
    </radio-group-inline>

    <div></div>

    <radio-group-inline
        v-if="portalContentAndDesignStore.portalLayoutSettings?.public_page_content_layout !== 'one'"
        label="Layout style"
        name="public_page_content_layout_style"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.public_page_content_layout_style ?? 'border'"
        @update:model-value="portalContentAndDesignStore.portalLayoutSettings.public_page_content_layout_style = $event"
        :options="[
          { value: 'border', label: 'Border'},
          { value: 'shadow', label: 'Shadow'},
          { value: 'none', label: 'None'}
    ]">
    </radio-group-inline>

    <radio-group-inline-color
        v-if="portalContentAndDesignStore.portalLayoutSettings?.public_page_content_layout !== 'one'"
        label="Layout corners"
        name="public_page_content_layout_corners"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.public_page_content_layout_corners ?? 'rounded-xl'"
        @picked="portalContentAndDesignStore.portalLayoutSettings.public_page_content_layout_corners = $event.finalValue"
        :options="[
          { value: 'none', label: 'data:image/svg+xml;base64,PHN2ZyBjbGFzcz0idy00IGgtNCIgd2lkdGg9IjI4cHgiIGhlaWdodD0iMjhweCIgdmlld0JveD0iMCAwIDI4IDI4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPiA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gPGcgaWQ9Ik1vYmlsZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyLjAwMDAwMCwgLTQ0LjAwMDAwMCkiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjQiPiA8cmVjdCBpZD0iUmVjdGFuZ2xlLUNvcHkiIHg9IjE0IiB5PSI0NiIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48L3JlY3Q+IDwvZz4gPC9nPiA8L3N2Zz4=', label_is_img: true},
          { value: 'rounded-lg', label: 'data:image/svg+xml;base64,PHN2ZyBjbGFzcz0idy00IGgtNCIgd2lkdGg9IjI4cHgiIGhlaWdodD0iMjhweCIgdmlld0JveD0iMCAwIDI4IDI4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPiA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gPGcgaWQ9Ik1vYmlsZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU1LjAwMDAwMCwgLTQ0LjAwMDAwMCkiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjQiPiA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSI1NyIgeT0iNDYiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgcng9IjQiPjwvcmVjdD4gPC9nPiA8L2c+IDwvc3ZnPg==', label_is_img: true},
          { value: 'rounded-xl', label: 'data:image/svg+xml;base64,PHN2ZyBjbGFzcz0idy00IGgtNCIgd2lkdGg9IjI4cHgiIGhlaWdodD0iMjhweCIgdmlld0JveD0iMCAwIDI4IDI4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPiA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gPGcgaWQ9Ik1vYmlsZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU1LjAwMDAwMCwgLTQ0LjAwMDAwMCkiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjQiPiA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSI1NyIgeT0iNDYiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgcng9IjQiPjwvcmVjdD4gPC9nPiA8L2c+IDwvc3ZnPg==', label_is_img: true},
          { value: 'rounded-3xl', label: 'data:image/svg+xml;base64,PHN2ZyBjbGFzcz0idy00IGgtNCIgd2lkdGg9IjI4cHgiIGhlaWdodD0iMjhweCIgdmlld0JveD0iMCAwIDI4IDI4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPiA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gPGcgaWQ9Ik1vYmlsZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTk4LjAwMDAwMCwgLTQ0LjAwMDAwMCkiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjQiPiA8cmVjdCBpZD0iUmVjdGFuZ2xlLUNvcHktMiIgeD0iMTAwIiB5PSI0NiIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiByeD0iOCI+PC9yZWN0PiA8L2c+IDwvZz4gPC9zdmc+', label_is_img: true},
    ]">
    </radio-group-inline-color>

    <radio-group-inline-color
        v-if="portalContentAndDesignStore.portalLayoutSettings?.public_page_content_layout !== 'one'"
        label="Content background"
        name="public_page_content_background_color"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.public_page_content_background_color ?? 'white'"
        @picked="portalContentAndDesignStore.portalLayoutSettings.public_page_content_background_color = $event.finalValue"
        :options="[
          { value: 'white', label: 'bg-white', label_is_class: true},
          { value: 'gray-50', label: 'bg-gray-50', label_is_class: true},
          { value: 'gray-100', label: 'bg-gray-100', label_is_class: true},
          { value: 'gray-200', label: 'bg-gray-200', label_is_class: true},
          { value: 'gray-300', label: 'bg-gray-300', label_is_class: true},
          { value: 'custom', label: 'Custom', custom: { name: 'public_page_content_background_color', placeholder: '', type: 'input' }},
    ]">
    </radio-group-inline-color>

    <radio-group-inline-color
        label="Text color"
        name="public_page_content_text_color"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.public_page_content_text_color ?? 'gray-800'"
        @picked="portalContentAndDesignStore.portalLayoutSettings.public_page_content_text_color = $event.finalValue"
        :options="[
          { value: 'gray-900', label: 'bg-gray-900', label_is_class: true},
          { value: 'gray-800', label: 'bg-gray-800', label_is_class: true},
          { value: 'gray-700', label: 'bg-gray-700', label_is_class: true},
          { value: 'gray-600', label: 'bg-gray-600', label_is_class: true},
          { value: 'gray-500', label: 'bg-gray-500', label_is_class: true},
          { value: 'custom', label: 'Custom', custom: { name: 'public_page_content_text_color', placeholder: '', type: 'input' }},
    ]">
    </radio-group-inline-color>

    <template v-if="!portalContentAndDesignStore.portalLayoutSettings.portal_layout_brand_primary_color_as_partner_and_pages_primary">
        <radio-group-inline-color
            label="Link color"
            name="public_page_content_link_color"
            :model-value="portalContentAndDesignStore.portalLayoutSettings.public_page_content_link_color ?? 'teal-600'"
            @picked="portalContentAndDesignStore.portalLayoutSettings.public_page_content_link_color = $event.finalValue"
            :options="[
              { value: 'indigo-700', label: 'bg-indigo-700', label_is_class: true},
              { value: 'blue-700', label: 'bg-blue-700', label_is_class: true},
              { value: 'cyan-700', label: 'bg-cyan-700', label_is_class: true},
              { value: 'teal-600', label: 'bg-teal-600', label_is_class: true},
              { value: 'gray-900', label: 'bg-gray-900', label_is_class: true},
              { value: 'custom', label: 'Custom', custom: { name: 'public_page_content_link_color', placeholder: '', type: 'input' }},
        ]"
        >
        </radio-group-inline-color>

        <radio-group-inline-color
            label="Button color"
            name="public_page_content_button_color"
            :model-value="portalContentAndDesignStore.portalLayoutSettings.public_page_content_button_color ?? 'teal'"
            @picked="portalContentAndDesignStore.portalLayoutSettings.public_page_content_button_color = $event.finalValue"
            :options="[
              { value: 'indigo', label: 'bg-indigo-700', label_is_class: true},
              { value: 'blue', label: 'bg-blue-700', label_is_class: true},
              { value: 'cyan', label: 'bg-cyan-700', label_is_class: true},
              { value: 'teal', label: 'bg-teal-600', label_is_class: true},
              { value: 'black', label: 'bg-black', label_is_class: true},
              { value: 'custom', label: 'Custom', custom: { name: 'public_page_content_button_color', placeholder: '', type: 'input' }},
    ]"
        >
        </radio-group-inline-color>
    </template>

    <radio-group-inline
        label="Input style"
        name="public_page_content_input_style"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.public_page_content_input_style ?? 'white'"
        @update:model-value="portalContentAndDesignStore.portalLayoutSettings.public_page_content_input_style = $event"
        :options="[
        { value: 'white', label: 'White'},
        { value: 'transparent', label: 'Transparent'}
    ]">
    </radio-group-inline>
</template>
